import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Badge,
} from "reactstrap";
import classnames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import TableContainer from "../../components/common/tableContainer";
import Loader from "../../components/common/loader";
import SwiperCore, { Autoplay } from "swiper";
import { getId, getRole } from "../../utils/helpers/custom";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import { adminProfile, profile } from "../../api/profileApi";
import { checkStatusCodeSuccess, CommonLabel, dateFormat, DocPDFNote, HandleResponse, onError, ResponseType, Roles } from "../../utils/helpers/common";
import {
  InputPlaceHolder,
  SelectPlaceHolder,
  validationMessages,
} from "../../utils/helpers/validationMasseges";
import { listOfData } from "../../api/commonApi";
import userDummyImg from "../../../src/assets/image/auth-one-bg.jpg";
import { toast } from "react-toastify";
import { attachments, ResponseStatusEnum } from "../../utils/helpers/enums";
import {
  addDocumentDetails,
  addEducationDetails,
  deleteDocumentDetails,
  viewDocumentDetails,
} from "../../api/documentsDetailsApi";
import { listOfResources } from "../../api/resourcesApi";
import { baseImageURL } from "../../api/baseURL";
import { aadharRegex } from "../../utils/helpers/validationMasseges";
import NoResultsMessage from "../../components/noResultMessage";
import { EmployeeLabels } from "../../common/constant/Employee";
import BaseInput from "../../components/BaseComponents/BaseInput";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import BaseButton from "../../components/BaseComponents/BaseButton";

const Profile = () => {
  const [profileData, setprofileData] = useState([]);
  const profileId = getId();
  const role = getRole();
  const [resUserDetails, setResUserDetails] = useState({});
  const [resBankDetails, setResBankDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [employeeAddressData, setEmployeeAddressData] = useState({});
  const [employeeAddressDetailData, setEmployeeAddressDetailData] = useState(
    {}
  );
  const [employeeAddressDetailData1, setEmployeeAddressDetailData1] = useState(
    {}
  );
  const [educationData, setEducationData] = useState({});
  const [employeeReportData, setEmployeeReportData] = useState([]);
  const [emergencyContactNameData, setEmergencyContactNameData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const viewAdminProfile = () => {
    setLoading(true);
    listOfData({
      modelName: "qualificationModel",
    })
      .then((res) => {
        setQualification(res?.data?.map((item) => ({
          value: item?.id,
          label:item?.qualification,
        })));
      })
      .catch((err) => err)
      .finally(() => { });

    adminProfile(profileId)
      .then((resp) => {
        setprofileData(resp.data);
        if (resp.data.userDetails === null) {
          setResUserDetails(null);
        } else {
          setResUserDetails(resp.data.userDetails);
        }
        if (resp.data.emergencyContact.length === 0) {
          setEmergencyContactNameData(null);
        } else {
          setEmergencyContactNameData(resp.data.emergencyContact);
        }
        if (resp.data.address === null) {
          setEmployeeAddressData(null);
        } else {
          setEmployeeAddressData(resp.data.address);
          setEmployeeAddressDetailData(resp.data.address.city);
          setEmployeeAddressDetailData1(resp.data.address.state);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  const viewHrEmployeeProfile = () => {
    setLoading(true);
    listOfData({
      modelName: "qualificationModel",
    })
      .then((res) => {
        setQualification(res?.data?.map((item) => ({
          value: item?.id,
          label:item?.qualification,
        })));
      })
      .catch((err) => err)
      .finally(() => { });

    profile(profileId)
      .then((resp) => {
        setprofileData(resp.data);
        if (resp.data.userDetails === null) {
          setResUserDetails(null);
        } else {
          setResUserDetails(resp.data.userDetails);
        }
        if (resp.data.bankDetails === null) {
          setResBankDetails(null);
        } else {
          setResBankDetails(resp.data.bankDetails);
        }
        if (resp?.data?.educationDetails === null) {
          setEducationData(null);
        } else {
          setEducationData(resp?.data?.educationDetails);
        }
        if (resp.data.emergencyContact.length === 0) {
          setEmergencyContactNameData(null);
        } else {
          setEmergencyContactNameData(resp.data.emergencyContact);
        }
        if (resp.data.address === null) {
          setEmployeeAddressData(null);
        } else {
          setEmployeeAddressData(resp.data.address);
          setEmployeeAddressDetailData(resp.data.address.city);
          setEmployeeAddressDetailData1(resp.data.address.state);
        }
        if (resp.data.reportTo === null) {
          setEmployeeReportData(null);
        } else {
          setEmployeeReportData(resp.data.reportTo);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (role === Roles.Admin) {
      viewAdminProfile();
    } else {
      viewHrEmployeeProfile();
    }
  }, []);

  SwiperCore.use([Autoplay]);

  const [activeTab, setActiveTab] = useState("1");
  const [deleteModal, setDeleteModal] = useState(false);
  const [todo, setTodo] = useState(null);
  const [modalTodo, setModalTodo] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [fileName, setFileName] = useState("");
  const [resourcesData, setResourcesData] = useState([]);

  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
      setTodo(null);
      setFileName("");
      validation.resetForm();
      validationAadhardocument.resetForm();
      validationdocument.resetForm();
      setNewimage(null);
    } else {
      validation.resetForm();
      validationAadhardocument.resetForm();
      validationdocument.resetForm();
      setModalTodo(true);
    }
  }, [modalTodo]);

  const [qualification, setQualification] = useState([]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleTodoClicks = () => {
    setTodo("");
    setModalTodo(!modalTodo);
    setIsEdit(false);
    toggle();
    validation.resetForm();
    validationAadhardocument.resetForm();
    validationdocument.resetForm();
  };

  const handleApprove = (row) => {
    setSelectedRow({ ...row, action: 'to delete this record' });
    setDeleteModal(true);
  };

  const handleConfirmation = () => {
    deleteDocumentDetails(
      {
        documentNameId: selectedRow.documentsName.id,
      },
      profileId
    )
      .then((res) => {
        if(checkStatusCodeSuccess(res?.data?.statusCode)) {
          toast.success(res.data.message);
          listofDocument();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });

    // Close the modal
    setDeleteModal(false);
    setSelectedRow(null);
  }

  const documentColumns = useMemo(
    () => [
      {
        Header: EmployeeLabels.DocumentType,
        accessor: "documentsName.fileName",
        filterable: false,
      },
      {
        Header: EmployeeLabels.UpdateDate,
        accessor: "updatedAt",
        filterable: false,
        Cell: (cell) => [
          <>
            {dateFormat(cell?.row?.original?.updatedAt)}
          </>
        ]
      },
      {
        Header: CommonLabel.Action,
        Cell: (cellProps) => {
          const orderData = cellProps.row.original;
          const fileURL = `${baseImageURL}${orderData?.fileUpload}`

          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit">
                <a
                  href={fileURL}
                  target="_blank"
                  download
                  className="text-primary d-inline-block edit-item-btn"
                  rel="noreferrer"
                >
                  <i className="ri-download-fill fs-16"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <Link
                  to=""
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    const orderData = cellProps.row.original;
                    if (
                      orderData.fileName === EmployeeLabels.Education ||
                      orderData.fileName === EmployeeLabels.AadharCard ||
                      orderData.fileName === EmployeeLabels.PanCard ||
                      orderData.fileName === EmployeeLabels.DrivingLicense
                    ) {
                      handleApprove(orderData);
                    } else {
                      handleApprove(orderData);
                    }
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      }
    ],
    []
  );

  const listOfResourcesProfile = () => {
    setLoading(true);
    listOfResources(profileId)
      .then((res) => {
        setResourcesData(res.data.data);
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };


  const columns2 = useMemo(() => [
    {
      Header: EmployeeLabels.CollegeName,
      accessor: "collegeName",
      filterable: false,
    },
    {
      Header: EmployeeLabels.Qualification,
      accessor: "qualification.qualification",
      filterable: false,
    },
    {
      Header: EmployeeLabels.Year,
      accessor: "passingYear",
      filterable: false,
    },
  ]);

  const columns = useMemo(() => [
    {
      Header: EmployeeLabels.ResourceName,
      accessor: "resourcesDetails.resourceName",
      filterable: false,
    },
    {
      Header: EmployeeLabels.ResourceID,
      accessor: "resourcesDetails.resourceNo",
      filterable: false,
    },
    {
      Header: EmployeeLabels.AllocatedDate,
      accessor: "resourceAllocationDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.resourceAllocationDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate ? dateFormat(date) : "---"}
          </div>
        );
      },
      filterable: false,
    },
    {
      Header: EmployeeLabels.SubmittedDate,
      accessor: "returnDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.returnDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate ? dateFormat(date) : "---"}
          </div>
        );
      },
      filterable: false,
    },
  ]);

  const [newImage, setNewimage] = useState(null);

  const uploadImage = (e) => {
    setNewimage(e.target.files[0]);
    validationEducation.setFieldValue("fileUpload", e.target.files[0]);
    fileName === EmployeeLabels.AadharCard
      ? validationAadhardocument.setFieldValue("fileUpload", e.target.files[0])
      : validationdocument.setFieldValue("fileUpload", e.target.files[0]);
  };
  const inputRef = useRef(null);

  const handleRemoveFile = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setNewimage(null);
    validationEducation.setFieldValue("fileUpload", "");
    fileName === EmployeeLabels.AadharCard
      ? validationAadhardocument.setFieldValue("fileUpload", "")
      : validationdocument.setFieldValue("fileUpload", "");
  };
  const listofDocument = () => {
    setLoading(true);
    viewDocumentDetails(profileId)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.data?.statusCode)) {
          setDocumentData(res.data.data);
        } else {
          setDocumentData([]);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      leaveType: (todo?.leaveType) || "",
      totalDays: (todo?.totalDays) || "",
      reason: (todo?.reason) || "",
      dueDate: (todo?.dueDate) || "",
    },
    validationSchema: Yup.object({
      dueDate: Yup.string().required(validationMessages.required(EmployeeLabels.Date)),
      leaveType: Yup.string().required(validationMessages.required(EmployeeLabels.LeaveType)),
      totalDays: Yup.string().required(validationMessages.required(EmployeeLabels.NumberOfDays)),
      reason: Yup.string().required(validationMessages.required(EmployeeLabels.Reason)),
    }),
    onSubmit: (values) => {
      validation.resetForm();
      toggle();
    },
  });
  document.title = EmployeeLabels.Profile;

  const validationEducation = useFormik({
    enableReinitialize: true,
    initialValues: {
      qualification: "",
      collageName: "",
      passingYear: "",
      fileUpload: "",
    },
    validationSchema: Yup.object({
      qualification: Yup.string().required(validationMessages.required(EmployeeLabels.Qualification)),
      collageName: Yup.string().required(validationMessages.required(EmployeeLabels.CollegeName)),
      passingYear: Yup.number().required(validationMessages.required(EmployeeLabels.PassingYear)),
      fileUpload: Yup.mixed().test('is-pdf', CommonLabel.PDFFileMessage, (value) => {
        if (value) {
          return value && value?.type === ResponseType.Pdf;
        }
        return true; 
      }).required(validationMessages.required(EmployeeLabels.File)),
    }),
    onSubmit: (values) => {
      setLoading(true);
      setModalTodo(false);
      setFileName("");
      addEducationDetails({
        userId: profileId,
        qualificationId: values?.qualification,
        fileName: fileName,
        collegeName: values?.collageName,
        passingYear: values?.passingYear,
        fileUpload: newImage,
      })
        .then((res) => {
          if (checkStatusCodeSuccess(res?.data?.statusCode)) {
            toast.success(res?.data?.message);
            setNewimage(null);
            listofDocument();
          } else {
            toast.error(res?.message);
          }
          setModalTodo(false);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
      validationEducation.resetForm();
    },
  });

  const validationAadhardocument = useFormik({
    enableReinitialize: true,
    initialValues: {
      aadharDocumentNumber: "",
      fileUpload: "",
    },
    validationSchema: Yup.object({
      aadharDocumentNumber: Yup.string()
        .matches(aadharRegex, validationMessages.format(EmployeeLabels.AadharCardNumber))
        .min(12, validationMessages.minLength(EmployeeLabels.AadharCardNumber,12))
        .required(validationMessages.required(`${fileName} ${EmployeeLabels.Number}`)),
      fileUpload: Yup.mixed().test('is-pdf', CommonLabel.PDFFileMessage, (value) => {
        if (value) {
          return value && value?.type === ResponseType.Pdf;
        }
        return true; 
      }).required(validationMessages.required(EmployeeLabels.File)),
    }),
    onSubmit: (values) => {
      setLoading(true);
      setModalTodo(false);
      setFileName("");
      addDocumentDetails({
        userId: profileId,
        fileName: fileName?.value || fileName,
        documentNo: values?.aadharDocumentNumber,
        fileUpload: newImage,
      })
        .then((res) => {
          if (checkStatusCodeSuccess(res?.data?.statusCode)) {
            toast.success(res?.data?.message);
            setNewimage(null);
          } else {
            toast.error(res?.data?.message);
          }
          listofDocument();
          setModalTodo(false);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
      validationAadhardocument.resetForm();
    },
  });

  const validationdocument = useFormik({
    enableReinitialize: true,
    initialValues: {
      documentNumber: "",
      fileUpload: "",
    },
    validationSchema: Yup.object({
      documentNumber: Yup.string().required(
        validationMessages.required(`${fileName} ${EmployeeLabels.Number}`)
      ),
      fileUpload: Yup.mixed().test('is-pdf', CommonLabel.PDFFileMessage, (value) => {
        if (value) {
          return value && value?.type === ResponseType.Pdf;
        }
        return true; 
      }).required(validationMessages.required(EmployeeLabels.File)),
    }),
    onSubmit: (values) => {
      setLoading(true);
      setModalTodo(false);
      setFileName("");
      addDocumentDetails({
        userId: profileId,
        fileName: fileName?.value,
        documentNo: values?.documentNumber,
        fileUpload: newImage,
      })
        .then((res) => {
          if (checkStatusCodeSuccess(res?.data?.statusCode)) {
            toast.success(res?.data?.message);
            setNewimage(null);
          } else {
            toast.error(res?.data?.message);
          }
          listofDocument();
          setModalTodo(false);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
      validationdocument.resetForm();
    },
  });

  let data = documentData?.sort((a, b) => a?.id - b?.id);

  return (
    <React.Fragment>
      <div className="page-content">
        <ApproveRejectModal
          show={deleteModal}
          onDeleteClick={() => handleConfirmation()}
          onCloseClick={() => setDeleteModal(false)}
          action={selectedRow ? selectedRow?.action : ""}
        />
        <Container fluid>
          <div className="profile-foreground position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg">
              <img
                src={
                  profileData?.userDetails?.profileImage
                    ? `${baseImageURL}${profileData?.userDetails?.profileImage}`
                    : userDummyImg
                }
                onError={onError}
                alt=""
                className="profile-wid-img"
              />
            </div>
          </div>
          <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
            <Row className="g-4">
              <div className="col-auto">
                <div className="">
                  <img
                    src={
                      profileData?.userDetails?.profileImage
                        ? `${baseImageURL}${profileData?.userDetails?.profileImage}`
                        : userDummyImg
                    }
                    onError={onError}
                    alt="user-img"
                    className="rounded-circle p-0 avatar-lg img-thumbnail user-profile-image"
                  />
                </div>
              </div>

              <Col>
                <div className="p-2">
                  <h3 className="text-white mb-1">
                    {profileData?.firstName} {profileData?.lastName}
                  </h3>
                  {role === Roles.Employee && (
                    <p className="text-white-75">
                      <b>{EmployeeLabels.Role} : </b>{EmployeeLabels.Developer}
                    </p>
                  )}
                  <p className="text-white-75">
                    <b>{EmployeeLabels.PhoneNo} : </b>
                    {profileData?.phoneNo}
                  </p>
                  <p className="text-white-75">
                    <b>{EmployeeLabels.Email} : </b>
                    {profileData?.email}
                  </p>
                  {role === Roles.Employee && (
                    <p className="text-white-75">
                      <b>{EmployeeLabels.Senior} : </b>
                      {employeeReportData?.firstName}{" "}
                      {employeeReportData?.lastName}
                    </p>
                  )}
                </div>
              </Col>

              <Col xs={12} className="col-lg-auto order-last order-lg-0">
                <Row className="text text-white-50 text-center">
                  <Col lg={6} xs={4}>
                    {role === Roles.Admin && (
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <Link
                            to="/update-profile"
                            className="btn btn-success"
                          >
                            <i className="ri-edit-box-line align-bottom"></i>{" "}
                            {EmployeeLabels.EditProfile}
                          </Link>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <Row>
            <Col lg={12}>
              <div>
                <div className="d-flex">
                  {role !== Roles.Admin && (
                    <>
                      <Nav
                        pills
                        className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: activeTab === "1",
                            })}
                            onClick={() => {
                              toggleTab("1");
                              viewHrEmployeeProfile();
                            }}
                          >
                            <i className="ri-airplay-fill d-inline-block d-md-none"></i>{" "}
                            <span className="d-none d-md-inline-block">
                              {EmployeeLabels.Overview}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: activeTab === "2",
                            })}
                            onClick={() => {
                              toggleTab("2");
                              listOfResourcesProfile();
                            }}
                          >
                            <i className="ri-list-unordered d-inline-block d-md-none"></i>{" "}
                            <span className="d-none d-md-inline-block">
                              {EmployeeLabels.Resources}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: activeTab === "3",
                            })}
                            onClick={() => {
                              toggleTab("3");
                              listofDocument();
                            }}
                          >
                            <i className="ri-price-tag-line d-inline-block d-md-none"></i>{" "}
                            <span className="d-none d-md-inline-block">
                              {EmployeeLabels.Documents}
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <div className="flex-shrink-0">
                        <Link to="/update-profile" className="btn btn-success">
                          <i className="ri-edit-box-line align-bottom"></i> Edit
                          {EmployeeLabels.Profile}
                        </Link>
                      </div>
                    </>
                  )}
                </div>
                <TabContent activeTab={activeTab} className="pt-4">
                  <TabPane tabId="1">
                    <Row>
                      {loading === false ? (
                        <>
                          <Card>
                            <CardBody>
                              <h5 className="card-title mb-3">{EmployeeLabels.Info}</h5>

                              <Row xs="2">
                                <Col className="p-3">
                                  <th>{EmployeeLabels.DateOfJoining} :</th>
                                </Col>
                                <Col className="p-3">
                                  <td className="text-muted">
                                    {dateFormat(
                                      !profileData?.dateOfJoin
                                        ? HandleResponse.NoData
                                        : profileData?.dateOfJoin
                                    )}
                                  </td>
                                </Col>
                                <Col className="p-3">
                                  <th>{EmployeeLabels.AddressLine1} :</th>
                                </Col>
                                <Col className="p-3">
                                  <td className="text-muted">
                                    {employeeAddressData === null
                                      ? HandleResponse.NoData
                                      : employeeAddressData?.addressLine1}
                                  </td>
                                </Col>
                                <Col className="p-3">
                                  <th>{EmployeeLabels.AddressLine2} :</th>
                                </Col>
                                <Col className="p-3">
                                  <td className="text-muted">
                                    {employeeAddressData === null
                                      ? HandleResponse.NoData
                                      : employeeAddressData?.addressLine2}
                                  </td>
                                </Col>
                                <Col className="p-3">
                                  <th>{EmployeeLabels.City} :</th>
                                </Col>
                                <Col className="p-3">
                                  <td className="text-muted">
                                    {employeeAddressData === null
                                      ? HandleResponse.NoData
                                      : employeeAddressDetailData?.cityName}
                                  </td>
                                </Col>
                                <Col className="p-3">
                                  <th>{EmployeeLabels.State} :</th>
                                </Col>
                                <Col className="p-3">
                                  <td className="text-muted">
                                    {employeeAddressData === null
                                      ? HandleResponse.NoData
                                      : employeeAddressDetailData1?.stateName}
                                  </td>
                                </Col>
                                <Col className="p-3">
                                  <th>{EmployeeLabels.Gender} :</th>
                                </Col>
                                <Col className="p-3">
                                  <td className="text-muted">
                                    {!resUserDetails?.gender
                                      ? HandleResponse.NoData
                                      : resUserDetails?.gender}
                                  </td>
                                </Col>
                                <Col className="p-3">
                                  <th>{EmployeeLabels.DateOfBirth} :</th>
                                </Col>
                                <Col className="p-3">
                                  <td className="text-muted">
                                    {dateFormat(
                                      !resUserDetails?.dob
                                        ? HandleResponse.NoData
                                        : resUserDetails?.dob
                                    )}
                                  </td>
                                </Col>
                                {role !== Roles.Admin && (
                                  <>
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.Nationality} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {!resUserDetails?.nationality
                                          ? HandleResponse.NoData
                                          : resUserDetails?.nationality}
                                      </td>
                                    </Col>
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.Religion} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {!resUserDetails?.religion
                                          ? HandleResponse.NoData
                                          : resUserDetails?.religion}
                                      </td>
                                    </Col>
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.PersonalEmail} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {!resUserDetails?.personalEmail
                                          ? HandleResponse.NoData
                                          : resUserDetails?.personalEmail}
                                      </td>
                                    </Col>
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.SkypeEmail} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {!resUserDetails?.skypeId
                                          ? HandleResponse.NoData
                                          : resUserDetails?.skypeId}
                                      </td>
                                    </Col>
                                  </>
                                )}
                              </Row>
                            </CardBody>
                          </Card>
                          {role !== Roles.Admin && (
                            <>
                              <Card>
                                <CardBody>
                                  <h5 className="card-title mb-3">
                                    Emergency Contact
                                  </h5>

                                  {emergencyContactNameData === null ? (
                                    <NoResultsMessage />
                                  ) : (
                                    <Row xs="2">
                                      {emergencyContactNameData?.map(
                                        (data, index) => {
                                          return (
                                            <React.Fragment key={index}>
                                              {index === 1 ? (
                                                <hr className="fullwidth"></hr>
                                              ) : null}
                                              <Col className="p-3">
                                                <th>{EmployeeLabels.Name} :</th>
                                              </Col>
                                              <Col className="p-3">
                                                <td className="text-muted">
                                                  {data.name}
                                                </td>
                                              </Col>
                                              <Col className="p-3">
                                                <th>{EmployeeLabels.Relation} :</th>
                                              </Col>
                                              <Col className="p-3">
                                                <td className="text-muted">
                                                  {data?.relation}
                                                </td>
                                              </Col>
                                              <Col className="p-3">
                                                <th>{EmployeeLabels.PhoneNo} :</th>
                                              </Col>
                                              <Col className="p-3">
                                                <td className="text-muted">
                                                  {data?.phoneNo}
                                                </td>
                                              </Col>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </Row>
                                  )}
                                </CardBody>
                              </Card>

                              <Card>
                                <CardBody>
                                  <h5 className="card-title mb-3">
                                    {EmployeeLabels.BankDetail}
                                  </h5>

                                  <Row xs="2">
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.AccountHolderName} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {resBankDetails === null
                                          ? HandleResponse.NoData
                                          : resBankDetails?.holderName}
                                      </td>
                                    </Col>
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.BankName} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {resBankDetails === null
                                          ? HandleResponse.NoData
                                          : resBankDetails?.bankName}
                                      </td>
                                    </Col>
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.AccountNumber} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {resBankDetails === null
                                          ? HandleResponse.NoData
                                          : resBankDetails?.accountNo}
                                      </td>
                                    </Col>
                                    <Col className="p-3">
                                      <th>{EmployeeLabels.IFSCCode} :</th>
                                    </Col>
                                    <Col className="p-3">
                                      <td className="text-muted">
                                        {resBankDetails === null
                                          ? HandleResponse.NoData
                                          : resBankDetails.ifscCode}
                                      </td>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </>
                          )}
                        </>
                      ) : (
                          <Loader transparentBackground={true} />
                      )}
                    </Row>

                    {role !== Roles.Admin && (
                      <TabPane tabId="1">
                        <Card>
                          <CardBody>
                            <h5 className="card-title mb-3">
                              {EmployeeLabels.EducationInformation}
                            </h5>
                            {educationData.length > 0 ? (
                              <TableContainer
                                columns={columns2}
                                data={educationData || {}}
                                customPageSize={5}
                                divClass="table-responsive table-card mb-1"
                                tableClass="align-middle table-nowrap"
                                theadClass="table-light text-muted"
                              />
                            ) : (
                              <NoResultsMessage />
                            )}
                          </CardBody>
                        </Card>
                      </TabPane>
                    )}
                  </TabPane>

                  {role !== Roles.Admin && (
                    <TabPane tabId="2">
                      <Card>
                        <CardBody>
                          <h5 className="card-title mb-3">{EmployeeLabels.Resources}</h5>
                          {resourcesData?.length ? (
                            <TableContainer
                              columns={columns}
                              data={resourcesData || []}
                              isAddUserList={false}
                              customPageSize={5}
                              divClass="table-responsive table-card mb-1"
                              tableClass="align-middle table-nowrap"
                              theadClass="table-light text-muted"
                            />
                          ) : (
                            <NoResultsMessage />
                          )}
                        </CardBody>
                      </Card>
                    </TabPane>
                  )}

                  {role !== Roles.Admin && (
                    <TabPane tabId="3">
                      <Card>
                        <CardBody>
                          <div className="d-flex">
                            <h5 className="card-title mb-3">Documents</h5>
                            <div className="col-auto order-2 order-lg-3 ms-auto">
                              <BaseButton
                                color="primary"
                                type="button"
                                onClick={() => handleTodoClicks()}
                              >
                                {EmployeeLabels.Upload}
                              </BaseButton>
                            </div>
                          </div>
                          <TableContainer
                            columns={documentColumns}
                            data={data}
                            isAddUserList={false}
                            customPageSize={5}
                            divClass="table-responsive table-card mb-1"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light text-muted"
                          >
                            {documentData.length === 0 ? (
                              <NoResultsMessage />
                            ) : null}
                          </TableContainer>
                        </CardBody>
                      </Card>
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        id="createTask"
        isOpen={modalTodo}
        toggle={toggle}
        modalClassName="zoomIn"
        centered
        tabIndex="-1"
      >
        <ModalHeader toggle={toggle} className="p-3 bg-soft-success">
          {" "}
          Upload Document{" "}
        </ModalHeader>
        <ModalBody>
          <div id="task-error-msg" className="alert alert-danger py-2"></div>
          <Form
            id="creattask-form"
            onSubmit={(e) => {
              e.preventDefault();
              if (fileName === EmployeeLabels.Education) {
                validationEducation.handleSubmit();
              } else {
                if (fileName === EmployeeLabels.AadharCard) {
                  validationAadhardocument.handleSubmit();
                } else {
                  validationdocument.handleSubmit();
                }
              }
            }}
          >
            <div className="mb-3">
              <BaseSelect
                label={EmployeeLabels.DocumentType}
                name="name"
                options={attachments}
                placeholder={SelectPlaceHolder(EmployeeLabels.DocumentType)}
                value={fileName}
                handleChange={(field, value) => {
                  if (value !== "") {
                    validationEducation.resetForm();
                    validationAadhardocument.resetForm();
                    validationdocument.resetForm();
                    setFileName(value);
                    setNewimage(null);
                  }
                }}
                handleBlur={validation.handleBlur}
                error={validation.errors.name}
                touched={validation.touched.name}
                required
              />
            </div>

            {fileName !== "" && (
              <>
                {fileName === EmployeeLabels.Education ? (
                  <>
                    <div className="mb-3" key={EmployeeLabels.Education}>
                      <BaseSelect
                        label={EmployeeLabels.Qualification}
                        name="qualification"
                        options={qualification}
                        placeholder={SelectPlaceHolder(
                          EmployeeLabels.Qualification
                        )}
                        value={validationEducation.values.qualification}
                        handleChange={(field, value) =>
                          validationEducation.setFieldValue(field, value)
                        }
                        handleBlur={validationEducation.handleBlur}
                        error={validationEducation.errors.qualification}
                        touched={validationEducation.touched.qualification}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <BaseInput
                        name="collageName"
                        type="text"
                        label="College Name"
                        placeholder={InputPlaceHolder("college name")}
                        onChange={validationEducation.handleChange}
                        handleBlur={validationEducation.handleBlur}
                        value={validationEducation.values.collageName || ""}
                        touched={validationEducation.touched.collageName}
                        error={validationEducation.errors.collageName}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <BaseInput
                        name="passingYear"
                        type="number"
                        label="Passing Year"
                        placeholder={InputPlaceHolder("Passing year")}
                        onChange={validationEducation.handleChange}
                        handleBlur={validationEducation.handleBlur}
                        value={validationEducation.values.passingYear || ""}
                        touched={validationEducation.touched.passingYear}
                        error={validationEducation.errors.passingYear}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <BaseInput
                        ref={inputRef}
                        name="fileUpload"
                        type="file"
                        accept="application/pdf"
                        label={EmployeeLabels.File}
                        onChange={(e) => uploadImage(e)}
                        handleBlur={validationEducation.handleBlur}
                        touched={validationEducation.touched.fileUpload}
                        error={validationEducation.errors.fileUpload}
                        required
                      />
                      {newImage && (
                        <Badge color="primary" className="my-3">
                          {newImage?.name}{" "}
                          <BaseButton
                            color="primary"
                            className="px-2 py-1"
                            onClick={handleRemoveFile}
                          >
                            &times;
                          </BaseButton>
                        </Badge>
                      )}
                      <p className="notebold mt-2">
                        Note: Upload{" "}
                        {
                          qualification[
                            parseInt(
                              validationEducation?.values?.qualification
                            ) - 1
                          ]?.qualification
                        }{" "}
                        Marksheet (PDF Only)
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    {fileName === EmployeeLabels.AadharCard ||
                    fileName === EmployeeLabels.AadharCard ? (
                      <>
                        <div className="mb-3" key={fileName}>
                          <BaseInput
                            ref={inputRef}
                            name="aadharDocumentNumber"
                            type="text"
                            placeholder={InputPlaceHolder(`${fileName} ${EmployeeLabels.Number}`)}
                            label={`${fileName} ${EmployeeLabels.Number}`}
                            onChange={(e) => {
                              validationAadhardocument.handleChange(e)
                            }}
                            handleBlur={validationAadhardocument.handleBlur}
                            value={
                              validationAadhardocument.values
                                .aadharDocumentNumber || ""
                            }
                            touched={
                              validationAadhardocument.touched
                                .aadharDocumentNumber
                            }
                            error={
                              validationAadhardocument.errors
                                .aadharDocumentNumber
                            }
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <BaseInput
                            ref={inputRef}
                            name="fileUpload"
                            type="file"
                            accept="application/pdf"
                            label={EmployeeLabels.File}
                            onChange={(e) => uploadImage(e)}
                            handleBlur={validationAadhardocument.handleBlur}
                            touched={
                              validationAadhardocument.touched.fileUpload
                            }
                            error={validationAadhardocument.errors.fileUpload}
                            required
                          />

                          <div>
                            {newImage && (
                              <Badge color="primary" className="my-3">
                                {newImage?.name}{" "}
                                <BaseButton
                                  color="primary"
                                  className="px-2 py-1"
                                  onClick={() => handleRemoveFile()}
                                >
                                  &times;
                                </BaseButton>
                              </Badge>
                            )}
                          </div>

                          <p className="notebold mt-2">
                            {DocPDFNote(fileName)}
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="mb-3"
                          key={
                            fileName === EmployeeLabels.PanCard ||
                            fileName === EmployeeLabels.PanCard
                              ? EmployeeLabels.PanCard
                              : EmployeeLabels.DrivingLicense
                          }
                        >
                          <BaseInput
                            ref={inputRef}
                            name="documentNumber"
                            type="text"
                            placeholder={InputPlaceHolder(
                              `${fileName} ${EmployeeLabels.Number}`
                            )}
                            label={`${fileName} ${EmployeeLabels.Number}`}
                            onChange={validationdocument.handleChange}
                            handleBlur={validationdocument.handleBlur}
                            value={
                              validationdocument.values.documentNumber || ""
                            }
                            touched={validationdocument.touched.documentNumber}
                            error={validationdocument.errors.documentNumber}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <BaseInput
                            ref={inputRef}
                            name="fileUpload"
                            type="file"
                            accept="application/pdf"
                            label={EmployeeLabels.File}
                            onChange={(e) => uploadImage(e)}
                            handleBlur={validationdocument.handleBlur}
                            touched={validationdocument.touched.fileUpload}
                            error={validationdocument.errors.fileUpload}
                            required
                          />

                          <div>
                            {newImage && (
                              <Badge color="primary" className="my-3">
                                {newImage?.name}{" "}
                                <BaseButton
                                  color="primary"
                                  className="px-2 py-1"
                                  onClick={() => handleRemoveFile()}
                                >
                                  &times;
                                </BaseButton>
                              </Badge>
                            )}
                          </div>

                          <p className="notebold mt-2">
                            {DocPDFNote(fileName)}
                          </p>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            )}
            <div className="hstack gap-2 justify-content-end">
              <BaseButton
                type="button"
                color="ghost-success"
                onClick={() => toggle()}
              >
                <i className="ri-close-fill align-bottom"></i>{" "}
                {role === Roles.Admin ? CommonLabel.Reject : CommonLabel.Cancel}
              </BaseButton>
              <BaseButton
                type="submit"
                color="primary"
                id="addNewTodo"
              >
                {CommonLabel.Save}
              </BaseButton>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default Profile;
